import { render, staticRenderFns } from "./UsersPendingInvites.vue?vue&type=template&id=6dd3026e&scoped=true&"
import script from "./UsersPendingInvites.vue?vue&type=script&lang=js&"
export * from "./UsersPendingInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3026e",
  null
  
)

export default component.exports